<template>
    <div :class="['visual-floor', {'is-show': isReady}]">
        <Canvas>
            <Pointer slot="pointer"/>
        </Canvas>
        <Vr/>
        <Compass/>
        <Breadcrumbs/>
        <Rotate/>
        <Filters/>
    </div>
</template>

<style lang="scss">
    @import "./Floor.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Canvas from '../../components/Canvas/Canvas';
import Compass from '../../components/Compass/Compass';
import Filters from '../../components/Filters/Filters';
import Pointer from '../../components/Pointer/Pointer';
import Rotate from '../../components/Rotate/Rotate';
import store from '../../store';
import Vr from '../../components/Vr/Vr';

export default {
    components: {
        Pointer,
        Canvas,
        Compass,
        Breadcrumbs,
        Vr,
        Filters,
        Rotate
    },

    computed: {...mapGetters({isReady: 'GET_IS_READY'})},

    methods: {...mapActions(['send'])},

    beforeRouteEnter(to, from, next) {
        /**
         * Отправляет данные на сервер.
         */
        const body = {
            step    : 'floor',
            building: to.params.buildingId || '',
            section : to.params.sectionId || ''
        };

        store.dispatch('send', body).then(() => {
            next();
        });
    }
};
</script>
